import React from "react";
import { ConnectedProps, connect, useSelector } from "react-redux";

import {
  getModelGridFlowLayerOpen,
  getModelGridLayerOpen,
  getWaterdepthLayerOpen,
  setModelGridFlowLayerOpen,
  setModelGridLayerOpen,
  setWaterDepthLayerOpen,
} from "./../state/layerCalculationMenu";
import LayerSubMenu from "./LayerSubMenu";

interface Props extends ConnectedProps<typeof connector> {
  calculationLayerType: string;
  calculationDisplayType: string;
  checkboxStyling?: boolean;
}

const LayerMenuCalculationLayer: React.FC<Props> = (props) => {
  const GridLayerVisible = useSelector(getModelGridLayerOpen);
  const GridFlowLayerVisible = useSelector(getModelGridFlowLayerOpen);
  const waterdepthLayerVisible = useSelector(getWaterdepthLayerOpen);
  const { calculationLayerType, calculationDisplayType } = props;
  const currentLayerVisible =
    (calculationLayerType === "Model grid" && GridLayerVisible) ||
    (calculationLayerType === "Model grid flow" && GridFlowLayerVisible) ||
    (calculationLayerType === "Water Depth" && waterdepthLayerVisible);

  return (
    <LayerSubMenu.Item
      active={currentLayerVisible}
      onClick={() => {
        if (calculationLayerType === "Model grid") {
          props.setModelGridLayerOpen(!currentLayerVisible);
        } else if (calculationLayerType === "Model grid flow") {
          props.setModelGridFlowLayerOpen(!currentLayerVisible);
        } else if (calculationLayerType === "Water Depth") {
          props.setWaterDepthLayerOpen(!currentLayerVisible);
        }
      }}
    >
      <LayerSubMenu.Item.Name>{calculationDisplayType}</LayerSubMenu.Item.Name>
      <LayerSubMenu.Item.Legend>
        {calculationLayerType === "Water Depth" ? (
          <LayerSubMenu.Item.Legend.Gradient title={`min:${0} - max${"50cm"}`}>
            {/* Lateron we probably need to show the values next to the layer */}
            {/* {"0"} */}
            <LayerSubMenu.Item.Legend.Gradient.Image
              src="./assets/images/raster_legend_flow_2d.png"
              alt="Water depth color gradient"
            />
            {/* waterdepth always goes from 0 to value (value=currently 0.5, but could be higher in future or configurable later) */}
            {/* 0.5m */}
          </LayerSubMenu.Item.Legend.Gradient>
        ) : null}
      </LayerSubMenu.Item.Legend>
    </LayerSubMenu.Item>
  );
};

const connector = connect(null, {
  setModelGridLayerOpen,
  setModelGridFlowLayerOpen,
  setWaterDepthLayerOpen,
});

export default connector(LayerMenuCalculationLayer);
